import React from 'react';
import HeaderStyle from './Header.module.css' ;
import mealsImage from '../../image/meals.jpg';

import HeaderCardButton from './HeaderCardButton';

function Header(props) {
 
  return (
    <React.Fragment>
        <header className={HeaderStyle.header}>
            <h1>ReactMeals</h1>
            <HeaderCardButton onClick={props.onShowCartHandler}/>
        </header>
        <div className={HeaderStyle['main-image']}>
            <img src={mealsImage} alt="meals" />
        </div>
    </React.Fragment>
  )
}

export default Header;

